module.exports = __webpack_public_path__ + "assets/img/en.8fa62fab.jpg";